import { Spin, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { styled } from 'styled-components';
import TableActionButton from '../../ui/TableActionButton';
import Title from '../../ui/Title';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { deleteProduct, fetchProducts } from '../../../store/slices/product-slice';
import ConfirmDialog from '../../ui/ConfirmDialog';
import TightWrapper from '../../ui/TightWrapper';
import LoadingError from '../../ui/error/LoadingError';

const ProductTable = () => {
    const dispatch = useDispatch();
    const { isLoading, data, isError } = useSelector((state) => state.product);
    const [dataSource, setDataSource] = useState([]);

    let nullColumns = [];
    if(dataSource.length) {
      nullColumns = Object.keys(dataSource[0]).filter(key => dataSource.every(item => item[key] === null))
    }

    useEffect(() => {
        dispatch(fetchProducts());
    }, []);
    
    useEffect(() => {
        if(data.length >= 0) {
            setDataSource(
              data.map((item) => ({
                ...item,
                key: item.prod_id,
                edit_id: item.prod_id,
                delete_id: item.prod_id,
              }))
            );
        }
    }, [data]);

    const columns = [
      {
        title: 'Product Name',
        dataIndex: 'prod_name',
        key: 'prod_name',
      },
      {
        title: 'Issuer Name',
        dataIndex: 'issuer_name',
        key: 'issuer_name',
      },
      {
        title: 'ISIN',
        dataIndex: 'ISIN',
        key: 'ISIN',
      },
      {
        title: 'Coupon Rate',
        dataIndex: 'coupon_rate',
        key: 'coupon_rate',
      },
      {
        title: 'Tenure Maturity',
        dataIndex: 'tenure_maturity',
        key: 'tenure_maturity',
      },
      {
        title: 'RICS',
        dataIndex: 'RICS',
        key: 'RICS',
      },
      // {
      //   title: 'Updated On',
      //   dataIndex: 'addedOn',
      //   key: 'addedOn',
      //   render: (_, { addedOn }) => addedOn && addedOn.split(' ')[0]
      // },
      {
        title: 'Edit',
        dataIndex: 'edit_id',
        key: 'edit_id',
        render: (_, {edit_id}) => (
          <TightWrapper>
            <Link to={`/dashboard/product-form?mode=EDIT&id=${edit_id}`}>
              <TableActionButton bg='#10ac84'>Edit</TableActionButton>
            </Link>
          </TightWrapper>
        )
      },
      {
        title: 'Delete',
        dataIndex: 'delete_id',
        key: 'delete_id',
        render: (_, {delete_id}) => (
          <ConfirmDialog
              onConfirm={() => dispatch(deleteProduct({ id: delete_id }))}
            >
            <TightWrapper>
              <TableActionButton bg='#ff6b6b' >Delete</TableActionButton>
            </TightWrapper>
          </ConfirmDialog>
        )
      },
    ].filter((item) => !nullColumns.includes(item.key));;

    if(isLoading) return (
      <Spin 
          tip="Loading" 
          size="large" 
          className='loading-spiner'
      />
    );
    if(isError) return <LoadingError />;

    return (
        <Wrapper>
          <Title>Products</Title>
            <div className='card'>
                <Table 
                dataSource={dataSource}
                bordered
                size='medium'
                columns={columns} 
                style={{
                    marginTop: '10px',
                    padding: 0,
                }}
                />
            </div>
        </Wrapper>
    );
}

export default ProductTable;

const Wrapper = styled.div`
    width: 95%;
    margin: auto;
    overflow: auto;
    animation: slide-down 300ms ease-out forwards;
    p {
        color: ${({theme}) => theme.colors.primary};
    }
    .ant-table-tbody {
        border: none;
    }
    .ant-table-thead .ant-table-cell {
        background-color:  ${({theme}) => theme.colors.primary};
        color: white;
        border-radius: 0 !important;
    }
    .card {
        box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    }
`;

